// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";
import { Icon } from "semantic-ui-react";
import "./ApplicationMenuLoader.less";
import * as i18n from "../../config/i18n";
import { ApplicationMenuItem } from "./ApplicationMenuItem";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("menu", "loader");
export const ApplicationMenuLoader = () => /*#__PURE__*/_jsx(ApplicationMenuItem, {
  icon: /*#__PURE__*/_jsx(Icon, {
    className: className,
    loading: true,
    name: "spinner"
  }),
  content: i18n.menuLoading,
  disabled: true,
  "data-sentry-element": "ApplicationMenuItem",
  "data-sentry-component": "ApplicationMenuLoader",
  "data-sentry-source-file": "ApplicationMenuLoader.tsx"
});